import {Component} from '@angular/core'

@Component({
  selector: 'vmb-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  public year = new Date().getFullYear()
}
